import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { getSelectedLanguage } from 'utils/cookies'

export type LanguageState = 'en' | 'sv'

interface LanguageSliceState {
  selectedLanguage: LanguageState
}

const initialLanguage = getSelectedLanguage()

const initialState: LanguageSliceState = {
  selectedLanguage: initialLanguage,
}

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setSelectedLanguage: (state, action: PayloadAction<LanguageState>) => ({
      ...state,
      selectedLanguage: action.payload,
    }),
  },
})

export default languageSlice
